import get from 'transmute/get';
export const getConnectedAccountsAsyncData = get('connectedAccounts');